import React, { useState } from 'react';
import { icons } from 'utils/constants';
import './ConferenceCard.scss';

const ConferenceCard = ({
  logo,
  title,
  date,
  location,
  moreDetailsLink,
  event_short_name,
  setSelectEventShortName
}) => {
  return (
    <div id="conference-card-container">
      <div className="conferenceCard ">
        <div className="card-img">
          <img src={logo} alt="Event Logo" />
        </div>

        <p
          className={`text-14-400-24  cmt-16 text-dots-conference-segment `}
          style={{
            height: '48px',
          }}
          onClick={() => setSelectEventShortName(event_short_name)}
        >
          {title}
        </p>

        <div className="d-flex align-items-center text-14-300-18">
          <img src={icons.calendarEvent} className="w-16 h-16 cme-8" />
          {date}
        </div>
        <div className="d-flex align-items-center text-14-300-18 cmt-16">
          <img src={icons.locationEvent} className="w-16 h-16 cme-8" />{' '}
          {location}
        </div>

        <div className="cmt-16">
          <a
            href={moreDetailsLink}
            className="text-14-500-18 d-flex align-items-center color-7cff"
            style={{ textDecoration: 'none' }}
          >
            Event Details
            <img
              src={icons.rightArrowBlue}
              className="cms-9"
              style={{ height: '12px', width: '8px' }}
              alt="Right Arrow"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ConferenceCard;
